import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useMemo } from "react";
import { useOrganizationsList } from "@api/organization.api";
import { useWorkspacesList } from "@api/workspace.api";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { McpConnectionRow } from "../mcpConnectionsViewConfig";
import { connectionTargetDisplay } from "../mcpConnectionHelpers";
import styles from "../McpCliSettings.module.scss";

export const ConnectionTargetCell = memo(
    ({ row }: CellContext<ViewTableFeatures, McpConnectionRow, string>) => {
        const { grantTarget } = row.original;
        const { data: workspaces = [] } = useWorkspacesList(undefined, {
            enabled: grantTarget?.type === "workspaces",
        });
        const { data: organizations = [] } = useOrganizationsList({
            enabled: grantTarget?.type === "organizations",
        });

        const { label, tooltipNames } = useMemo(() => {
            const nameById = new Map(
                [...workspaces, ...organizations].map((target) => [
                    target.id,
                    target.name,
                ]),
            );
            return connectionTargetDisplay(grantTarget, nameById);
        }, [grantTarget, workspaces, organizations]);

        const targetLabel = (
            <span className={styles.connectionTarget}>{label}</span>
        );

        return (
            <ViewTableCell>
                {tooltipNames.length === 0 ? (
                    targetLabel
                ) : (
                    <Tooltip bullets={tooltipNames}>{targetLabel}</Tooltip>
                )}
            </ViewTableCell>
        );
    },
);
